<template>

  <div id="gallery2005">
      <div v-for="folder in pictureFolders" style="margin-top: 5rem;">
            <h2>{{folder.description}}</h2>
            <div>
                <b-carousel
                    id="carousel-no-anim"
                    style="text-shadow: 0px 0px 2px #000"
                    no-animation
                    :interval="10000"
                    controls
                >
                    <div v-for="picture in folder.pictures">
                        <b-carousel-slide v-bind:img-src="picture.fileDownloadUri"/>
                    </div>
                </b-carousel>
            </div>
      </div>
  </div>

</template>

<script>

    import {PICTURE_REQUEST} from '@/store/actions/pictures'

    export default {
      name: 'pictures',
      mounted () {
        console.log('Start first request');
        this.$store.dispatch(PICTURE_REQUEST, 2005);
      },
      computed: {
        pictureFolders: function() {
          console.log("Try to show pictures");
          return this.$store.getters.getPictures
        }
      },
    }

</script>